import gql from "graphql-tag";

// export const PICKUP_CONFIRMATION = gql`
//  mutation ($id: uuid!,$orderReadiness: jsonb!,$lrObject: jsonb!,$pickupConfirmation: String!, $dropPoint: jsonb!,
//   $pickupPoint: jsonb!, $orderId: uuid!, $internalstatus: uuid!, $orderDetailId: uuid!) {
//   update_orderDetails (
//     where: {id: {_eq: $orderDetailId}}
//     _set: {orderReadiness: $orderReadiness, lrObject: $lrObject, pickupConfirmation: $pickupConfirmation,
//     dropPoint: $dropPoint, pickupPoint: $pickupPoint}
//   ) {
//     returning {
//       id
//      }
//     }
//   }
// `
export const PICKUP_CONFIRMATION = gql`
 mutation ($pickupConfirmation: String!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {pickupConfirmation: $pickupConfirmation}
  ) {
    returning {
      id
     }
    } 
  }
`
export const PICKUP_READINESS = gql`
 mutation ($orderReadiness: jsonb!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {orderReadiness: $orderReadiness}
  ) {
    returning {
      id
     }
    } 
  }
`
export const SEND_PICKUP_EMAIL = gql`
 mutation ($lrObject: jsonb!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {lrObject: $lrObject}
  ) {
    returning {
      id
     }
    } 
  }
`
export const DISPATCH_VERIFICATION = gql`
 mutation ($dispactchVerification: jsonb!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {dispactchVerification: $dispactchVerification}
  ) {
    returning {
      id
     }
    } 
  }
`
export const LOAD_TRUCK = gql`
 mutation ($loadedInTruck: Boolean!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {loadedInTruck: $loadedInTruck}
  ) {
    returning {
      id
     }
    } 
  }
`
export const ENTER_EWAY_BILL = gql`
 mutation ($orderDetailId: uuid!, $isEwayBillVerified: Boolean!, $ewayBillNo: String!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {isEwayBillVerified: $isEwayBillVerified, ewayBillNo: $ewayBillNo}
  ) {
    returning {
      id
     }
    } 
  }
`